export const webmotorsLoaderStyles = {
	root: 'flex items-center justify-center',
	overlay: 'fixed inset-0 z-50 flex items-center justify-center bg-[#2e2d37]/80',
	svg: 'wm-loader-svg'
} as const;
